import * as React from 'react';
import { translate } from 'react-i18next';
import { IItemCardProps } from 'models/itemcard';
import * as c from 'models/constants';
import { ICustomer } from 'models/shop/customer';
import Customer from 'components/Common/Customer';
require('./style.scss');

interface IProps extends IItemCardProps {
	item: ICustomer;
	t?: (key: string, options?: any) => string;
}
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class CustomerItemCard extends React.Component<IProps, any> {
	constructor(props) {
		super(props);
	}

	public render() {
		const { item } = this.props;

		return (
			<div className="customer-item-card" onClick={() => this.props.goToCard?.(item?.id)}>
				<Customer customer={item} />
			</div>
		);
	}
}
export { CustomerItemCard };
